module.exports = __webpack_public_path__ + "static/media/lily_i_wen_su.5de6cf05.jpg";